'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ConversionFloatingCTAProps {
  scrollOffset?: number;
}

const ConversionFloatingCTA = ({ scrollOffset = 60 }: ConversionFloatingCTAProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > window.innerHeight * 0.5);
    };

    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    const throttledScroll = () => {
      if (timeoutId) return;
      timeoutId = setTimeout(() => {
        handleScroll();
        timeoutId = null;
      }, 16);
    };

    window.addEventListener('scroll', throttledScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', throttledScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  const handleCTAClick = () => {
    const element = document.getElementById('start-mvp');
    if (element) {
      window.scrollTo({ top: element.offsetTop - scrollOffset, behavior: 'smooth' });
    }
  };

  if (!isVisible) return null;

  return (
    <>
      <button
        onClick={handleCTAClick}
        className="fixed bottom-6 right-6 z-[900] hidden items-center gap-2 rounded-md bg-[var(--brand-orange)] px-5 py-3 font-sans text-sm font-semibold text-[var(--brand-ink)] transition-colors hover:bg-[#ffb01a] lg:flex"
        aria-label="Start Your MVP"
      >
        <span>Start Your MVP</span>
        <Icon name="ArrowRightIcon" size={16} />
      </button>

      <button
        onClick={handleCTAClick}
        className="fixed bottom-0 left-0 z-[900] flex w-full items-center justify-center gap-2 bg-[var(--brand-orange)] px-4 py-3.5 font-sans text-sm font-semibold text-[var(--brand-ink)] lg:hidden"
        style={{ paddingBottom: 'calc(0.875rem + env(safe-area-inset-bottom))' }}
        aria-label="Start Your MVP"
      >
        <span>Start Your MVP</span>
        <Icon name="ArrowRightIcon" size={16} />
      </button>
    </>
  );
};

export default ConversionFloatingCTA;
